'use client'

import React, { useMemo } from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useSupabase } from '@/hooks/useSupabase'

const Logo = () => {
  const pathname = usePathname() || ''
  const { user, loading: authLoading } = useSupabase()

  const logoHref = useMemo(() => {
    // ✅ /my/client, /client/* → /client 랜딩
    if (pathname.startsWith('/my/client') || pathname.startsWith('/client')) {
      return '/client'
    }
    
    // ✅ /my/freelancer/*, /freelancer/* → / 랜딩
    if (pathname.startsWith('/my/freelancer') || pathname.startsWith('/freelancer')) {
      return '/'
    }
    
    // ✅ 기본값: 현재 스코프 랜딩으로
    return pathname.startsWith('/client') ? '/client' : '/'
  }, [pathname])

  return (
    <Link href={logoHref} className="text-subtitle1 hover:cursor-pointer" prefetch={false}>
      LINKUS
    </Link>
  )
}

export default Logo
